<template>
  <div>
    <div class="row">
      <div class="col-6">
        <h2>Image Files</h2>
        <button type="button" class="btn btn-primary" @click="showUploadModal">Upload New Image</button>
      </div>
      <div class="col-6 text-right">
        <div class="d-flex align-items-end mb-1">
          <label class="w-25 text-right">Search:&nbsp;</label>
          <div class="w-75">
            <input 
              class="w-100 form-control"
              style="border-radius: 4px"
              v-model="query_text"
              maxlength="100"
              placeholder="Search for image by name"
            />
          </div>
        </div>
        <div class="d-flex align-items-end my-1">
          <label class="w-25 text-right">Type:&nbsp;</label>
          <div class="w-75">
            <v-select
              multiple
              v-model="selected_tags"
              :options="['alert', 'announcement']"
              placeholder="Showing All"
            ></v-select>
          </div>
        </div>
      </div>
    </div>
    <hr>
    <div class="d-flex flex-wrap justify-content-start">
      <div v-for="image in filtered_images" :key="image.image_id" class="m-3 d-flex flex-column flex-wrap">
        <div class="d-flex">
          <input class="w-100" id="name-input" v-model="image.name" />
          <div class="ml-auto d-flex">
            <button type="button" class="btn btn-primary d-inline" @click="editImage(image)"><i class="fa fa-save fa-fw" aria-hidden="true"></i></button>
            <button type="button" class="btn btn-danger d-inline" @click="deleteImage(image)"><i class="fa fa-trash fa-fw" aria-hidden="true"></i></button>
          </div>
        </div>
        <img :src="`/upload/images/visual_backgrounds/${image.filename}`" style="height: 220px; aspect-ratio: 16/9;" class="d-block"/>
        <div>
          <div class="form-check form-check-inline">
            <input class="form-check-input" type="checkbox" :id="'cbAlert' + image.image_id" v-model="image.alert">
            <label class="form-check-label" :for="'cbAlert' + image.image_id">Alert</label>
          </div>
          <div class="form-check form-check-inline">
            <input class="form-check-input" type="checkbox" :id="'cbAnnouncement' + image.image_id" v-model="image.announcement">
            <label class="form-check-label" :for="'cbAnnouncement' + image.image_id">Announcement</label>
          </div>
        </div>
      </div>
      <Modal modal_id='imageUploadModal' size='md'>
        <template v-slot:title>
          Upload Image
        </template>
        <template v-slot:body>
          <Upload :callback="upload" />
        </template>
      </Modal>
    </div>
  </div>
</template>
  
<script>
import { mapGetters, mapActions } from 'vuex'
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'
import Modal from '../../../components/Modal.vue'
import Upload from './Upload.vue'

export default {
  components: { Modal, Upload, vSelect },
  data() {
    return {
      query_text: '',
      selected_tags: []
    }
  },
  computed: {
    ...mapGetters({
      images: 'allImages'
    }),
    filtered_images() {
      return this.images.filter(image => {
        let include = this.selected_tags.length === 0 || (image.alert && this.selected_tags.includes('alert') || (image.announcement && this.selected_tags.includes('announcement')))
        if(include && this.query_text.trim() !== '' && !image.name.toLowerCase().includes(this.query_text.toLowerCase())) {
          include = false
        }
        return include
      })
    }
  },
  created() {
    this.$store.dispatch('getImages')
  },
  methods: {
    ...mapActions([
      'uploadImage',
      'editImage'
    ]),
    showUploadModal() {
      $('#imageUploadModal').modal('show') // eslint-disable-line
    },
    upload(uploadData) {
      const data = {
        file: uploadData.file,
        tags: uploadData.tags,
        name: uploadData.name
      }
      
      return this.uploadImage(data)
        .then((success) => {
            if(success) $('#imageUploadModal').modal('hide') // eslint-disable-line
          }
        ) 
    },
    deleteImage(image) {
      if(confirm('You are aboue to delete an image. Continue?')) {
        this.$store.dispatch('deleteImage', image)
      }
    }
  }
}
</script>